import { ref, onMounted, onUnmounted } from 'vue';

// Canvas (chart.js) can't read CSS variables, so we read the resolved token
// values off <html> and re-render when [data-theme] flips. `tick` is a reactive
// dep to thread into chart option computeds; `color()` reads a token live.
export function useThemeTick() {
  const tick = ref(0);
  const observers = [];
  onMounted(() => {
    const bump = () => {
      tick.value += 1;
    };
    // Super admin flips [data-theme] on <html>; the agent dashboard toggles the
    // `dark` class on <body>. The charts are shared, so watch both.
    [
      [document.documentElement, ['data-theme', 'class']],
      [document.body, ['class']],
    ].forEach(([target, attributeFilter]) => {
      if (!target) return;
      const obs = new MutationObserver(bump);
      obs.observe(target, { attributes: true, attributeFilter });
      observers.push(obs);
    });
  });
  onUnmounted(() => {
    observers.forEach(obs => obs.disconnect());
    observers.length = 0;
  });
  return tick;
}

export function color(name, fallback) {
  try {
    // Read off <body>, not <html>: the dashboard puts its `dark` class there, and the
    // super admin declares the tokens on :root, which <body> inherits either way.
    const target = document.body || document.documentElement;
    const v = getComputedStyle(target).getPropertyValue(name).trim();
    return v || fallback;
  } catch (e) {
    return fallback;
  }
}
